// App.tsx
import { RouterProvider } from 'react-router';
import { router } from 'src/router';

const App = () => {
  return (
    <RouterProvider router={router} />
  );
}

export default App;